import React from 'react';
import { checkSize, checkColor } from './svg.helper';

export function checkmarkSolid(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill={checkColor(color)}
          d="M12 2a10.001 10.001 0 11-.001 20.002A10.001 10.001 0 0112 2z"
        />
        <path
          fill="#FFF"
          d="M11.428 15.678c-.417.43-1.078.43-1.495 0L7.438 13.16a1.182 1.182 0 01-.42-1.128c.073-.43.371-.778.767-.896.396-.119.82.014 1.094.341l1.72 1.775 4.55-4.9a1.034 1.034 0 011.035-.317c.373.099.668.402.774.796a1.2 1.2 0 01-.26 1.112l-5.27 5.736z"
        />
      </g>
    </svg>
  );
}

export function errorSolid(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#DB232D"
          d="M12 2a10.001 10.001 0 11-.001 20.002A10.001 10.001 0 0112 2z"
        />
        <path
          fill="#FFF"
          d="M13.513 12.043l2.272-2.275a1.08 1.08 0 00-.1-1.41 1.08 1.08 0 00-1.408-.1l-2.315 2.233-2.24-2.275c-.428-.322-1.028-.28-1.407.1s-.421.98-.1 1.41l2.283 2.317-2.272 2.232a1.078 1.078 0 001.508 1.51l2.228-2.286 2.272 2.275a1.077 1.077 0 001.508-1.51l-2.23-2.22z"
        />
      </g>
    </svg>
  );
}

export function helpOutline(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12 2a10.001 10.001 0 11-.001 20.002A10.001 10.001 0 0112 2zm0 2a8 8 0 100 16 8 8 0 000-16zm0 12a1 1 0 110 2 1 1 0 010-2zm0-10c2.21 0 4 1.79 4 4 0 1.2-.94 1.94-1.77 2.59-.6.47-1.22 1-1.22 1.41A1 1 0 0112 15a1 1 0 01-1-1 3.84 3.84 0 012-3 1.64 1.64 0 00-1-3 2 2 0 00-2 2 1 1 0 01-2 0c0-2.21 1.79-4 4-4z"
        fill="#0C60A5"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function informationOutline(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12 2a10.001 10.001 0 11-.001 20.002A10.001 10.001 0 0112 2zm0 2a8 8 0 100 16 8 8 0 000-16zm0 5a1 1 0 01.993.883L13 10v7a1 1 0 01-1.993.117L11 17v-7a1 1 0 011-1zm0-3a1 1 0 110 2 1 1 0 010-2z"
        fill="#0C60A5"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function informationSolid(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#0C60A5"
          d="M12 2a10.001 10.001 0 11-.001 20.002A10.001 10.001 0 0112 2z"
        />
        <path
          fill="#FFF"
          d="M12 9a1 1 0 011 1v7a1 1 0 01-2 0v-7a1 1 0 011-1zm0-3a1 1 0 110 2 1 1 0 010-2z"
        />
      </g>
    </svg>
  );
}

export function warningSolid(size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <defs>
        <path
          data-testid="ads-warning-icon"
          id="warning-id"
          d="M12 17a1 1 0 110 2 1 1 0 010-2zm0-8a1 1 0 011 1v5a1 1 0 01-2 0v-5a1 1 0 011-1z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FDD13A"
          d="M21.871 19.507l-9-16.033c-.354-.632-1.389-.632-1.742 0l-9 16.033A1 1 0 003 21h18a1 1 0 00.871-1.493"
        />
        <use fill="#2A2E30" href="#warning-id" />
      </g>
    </svg>
  );
}
